import HeroIdentity from '../components/home/HeroIdentity';
import EventGallery from '../components/home/EventGallery';
import CapabilityPillars from '../components/home/CapabilityPillars';
import PartnershipProposal from '../components/home/PartnershipProposal';
import HostCta from '../components/home/HostCta';
import HomeFooter from '../components/home/HomeFooter';
import ScrollToTop from '../components/ScrollToTop';

export default function CustomerLanding() {
  return (
    <div className="app">
      <HeroIdentity />
      <EventGallery />
      <CapabilityPillars />
      <PartnershipProposal />
      <HostCta />
      <HomeFooter />
      <ScrollToTop />
    </div>
  );
}
